"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./ontodia/diagram/paper"), exports);
tslib_1.__exportStar(require("./ontodia/diagram/paperArea"), exports);
var workspaceMarkup_1 = require("./ontodia/workspace/workspaceMarkup");
exports.WorkspaceContextTypes = workspaceMarkup_1.WorkspaceContextTypes;
